export default __webpack_public_path__ + "static/media/sms-HIFI.12c93c88.png";